import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { UserService } from "@app/services/user.service";
import { Observable, from } from "rxjs";
import { tap, map } from "rxjs/operators";

@Injectable({
  providedIn: "root", // Use tree-shakable providers for better optimization
})
export class SessionGuardService {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.userService.isSessionActive()).pipe(
      tap((isSessionActive) => {
        console.log("isSessionActive", isSessionActive); // Log the session status
        if (!isSessionActive) {
          this.router.navigate(["/auth/logout"]); // Redirect to logout if session is not active
        }
      }),
      map((isSessionActive) => isSessionActive) // Pass the session status as the observable result
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
